// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog__container[data-v-c0bff800] {
  display: flex;
  flex-direction: column;
  margin: 30px;
  gap: 10px 0;
}
.dialog__title[data-v-c0bff800] {
  margin-bottom: 0;
}
.dialog__button[data-v-c0bff800] {
  margin-top: 6px;
  align-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/password-confirmation/dist/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".dialog__container[data-v-c0bff800] {\n  display: flex;\n  flex-direction: column;\n  margin: 30px;\n  gap: 10px 0;\n}\n.dialog__title[data-v-c0bff800] {\n  margin-bottom: 0;\n}\n.dialog__button[data-v-c0bff800] {\n  margin-top: 6px;\n  align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
